const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "98%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "燃料名称",
        prop: "fuelName",
        search: true,
        clearable: true,
      },
      {
        label: "燃料消耗单位",
        prop: "fuelUnit",
      },
      {
        label: "低位发热量(GJ/t或GJ/10^4Nm³)",
        prop: "lowerHeating",
        columnWidth: 230
      },
      {
        label: "单位热值含碳量(tC/TJ)",
        prop: "carbonUnitHeating",
        columnWidth: 170
      },
      {
        label: "碳氧化率(%)",
        prop: "oxidationRate",
      },
      {
        label: "分子量",
        prop: "molecularWeight",
      },
      {
        label: "备注",
        prop: "fuelRemark",
      }
    ]
  };
};

export default tableOption;
